import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';
import { ValueOf } from '@snack-uikit/utils';

import { EventOrWebinarType } from '../../../../types/backendContent';
import { CATEGORY_TAG_META, CATEGORY_TAGS } from '../constants';

type Category = ValueOf<typeof CATEGORY_TAGS>;

const isCategory = (value: string): value is Category => {
  return Object.values(CATEGORY_TAGS).includes(value as Category);
};

// TODO: replace once color is added to EventType.categories (EventCategory)
export const getEventCategoryMetaProps = ({
  categories,
}: EventOrWebinarType): HeroEventProps['category'] => {
  const category = categories[0];
  return isCategory(category.slug)
    ? {
        ...CATEGORY_TAG_META[category.slug],
        text: category.title,
      }
    : {
        text: category.title,
        appearance: 'neutral',
      };
};
